const BASE_URL = process.env.BASE_URL || "/";
const fileServer = process.env.VUE_APP_FILE_SERVER || "/";

export const config = {
  fileExtension: {
    csv: '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-Excel',
    video: 'video/*',
    images: 'image/*',
    document: 'image/*,.csv,' +
      ' application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,' +
      ' application/vnd.ms-Excel,' +
      ' .doc,' +
      ' .docx,' +
      ' .pdf,' +
      ' application/vnd.ms-powerpoint,' +
      ' application/mspowerpoint,' +
      ' application/x-mspowerpoint,' +
      ' application/vnd.openxmlformats-officedocument.presentationml.presentation',
  },
  url: {
    uploads: `${fileServer}/upload`,
  },
  baseUrl: BASE_URL,
};

export function getUploadsUrl(fileName){
  if(fileName){
    return `${fileServer}/resources/uploads/${fileName}`;
  }else{
    return BASE_URL + 'static/images/no-avatar.png'
  }
}
